document.addEventListener("DOMContentLoaded", () => {
  initTabs();
  initAccordion();
  initToggleButtons();
});

function initTabs() {
  const tabLinks = document.querySelectorAll(".tabs-section .tab-link");
  const tabContents = document.querySelectorAll(".tabs-section .tab-content");

  if (!tabLinks.length || !tabContents.length) return;

  tabLinks[0].classList.add("active");
  tabContents[0].classList.add("active");

  tabLinks.forEach((link) => {
    link.addEventListener("click", () => {
      const tabId = link.dataset.tab;
      tabLinks.forEach((el) => el.classList.remove("active"));
      tabContents.forEach((el) => el.classList.remove("active"));
      link.classList.add("active");
      const target = document.getElementById(tabId);
      if (target) {
        target.classList.add("active");
        adjustAccordionHeight(target);
      }
    });
  });
}

function initAccordion() {
  const headers = document.querySelectorAll(".accordion-header");
  const contents = document.querySelectorAll(".accordion-content");

  if (!headers.length || !contents.length) return;

  contents.forEach((el) => {
    el.style.transition = "height 0.3s ease";
    el.style.height = "0px";
    el.classList.remove("open");
  });

  setTimeout(() => {
    contents[0].style.height = contents[0].scrollHeight + "px";
    contents[0].classList.add("open");
    headers[0]?.classList.add("on");
  }, 100);

  headers.forEach((header) => {
    header.addEventListener("click", () => {
      const content = header.nextElementSibling;
      const isOpen = content.classList.contains("open");

      const scrollY = window.scrollY;

      contents.forEach((el) => {
        el.style.height = "0px";
        el.classList.remove("open");
      });

      headers.forEach((el) => el.classList.remove("on"));

      if (!isOpen) {
        content.classList.add("open");
        content.style.height = content.scrollHeight + "px";
        header.classList.add("on");
      }

      setTimeout(() => {
        window.scrollTo({ top: scrollY });
      }, 0);
    });
  });
}
function initToggleButtons() {
  const isArabic = window.location.pathname.includes('/ar') || document.documentElement.lang === 'ar';

  const viewMoreText = isArabic ? "عرض المزيد" : "View More";
  const viewLessText = isArabic ? "عرض أقل" : "View Less";

  document.querySelectorAll(".toggle-button").forEach((btn) => {
    btn.addEventListener("click", () => {
      const desc = btn.previousElementSibling;
      if (desc?.classList.contains("description-text")) {
        const isExpanded = desc.classList.contains("expanded");

        desc.classList.toggle("collapsed", isExpanded);
        desc.classList.toggle("expanded", !isExpanded);

        btn.textContent = isExpanded ? viewMoreText : viewLessText;

        const accordionContent = btn.closest(".accordion-content");
        if (accordionContent) {
          accordionContent.style.height = "auto";
          const newHeight = accordionContent.scrollHeight;
          accordionContent.style.height = newHeight + "px";
        }
      }
    });
  });
}


function adjustAccordionHeight(container) {
  const openContent = container.querySelector(".accordion-content.open");
  if (openContent) {
    openContent.style.height = "auto";
    const newHeight = openContent.scrollHeight;
    openContent.style.height = newHeight + "px";
  }
}
